module.exports = __webpack_public_path__ + "img/Belchen_2016_B_Asal-8554.dd42b89b.jpeg";